import { theTime } from 'src/app/utils/date-utils';

export const getDayDictKey = (date: Date) =>
  theTime(date).to(['DD', 'MM', 'YYYY'], '-');
  // TODO: check id dictKey should have day and month of one character
  //`${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

export const supportLevel2024 = 73;
export const supportLevel2025 = 75;
export const supportLevelMva2024 = supportLevel2024 * 1.25;
export const supportLevelMva2025 = supportLevel2025 * 1.25;
export const supportPercentage = 0.9;

export const getSupportLevel = (year: number) =>
  year > 2024 ? supportLevel2025 : supportLevel2024;
export const getSupportLevelMva = (year: number) =>
  year > 2024 ? supportLevelMva2025 : supportLevelMva2024;

export const getStromstotteHour = (
  pris: number,
  omrade: string,
  year: number
) => {
  const subtractValue =
    (pris / (omrade === 'NO4' ? 1 : 1.25) - getSupportLevel(year)) *
    supportPercentage *
    (omrade === 'NO4' ? 1 : 1.25);
  return subtractValue > 0 ? subtractValue : 0;
};
